import { FRAUD_SERVICE_URI } from "env";
import { assertOk, proxyFetch } from "./utils";

const fraudOpsProxy = proxyFetch(FRAUD_SERVICE_URI);

export const createSession = async (ctx, accountId) => {
  const response = await fraudOpsProxy(ctx, `/v2/session/${accountId}`, "POST");
  assertOk(response);
  return response.json();
};

export const createSessionV3 = async (ctx, accountId, flow) => {
  if (!accountId) throw new Error("Missing account ID");
  const response = await fraudOpsProxy(ctx, `/v3/session/${accountId}`, "POST", { widget_flow: flow || null });
  assertOk(response);
  return response.json();
};
